<div class="app">
    <quiz-app></quiz-app>
</div>